import * as Rx from 'rxjs';
const { Observable } = Rx;
const { of, ajax } = Observable;
import * as actions from '../actions/statusActions';
const apiUrls = require('../constants/apiUrls');
import statusEventCheck from '../status/statusEventCheck';
import * as mouseFlowUtils from '../utils/mouseFlowUtils';
import {
  TAG_SET_TECH_STATUS
  , TAG_GET_TECH_STATUS
} from '../constants/mouseFlow';
import { wowCustomHeader } from '../utils/wowCustomHeadersUtils';
import { getAccessTokenFromState } from 'utils/userManager';
import retryStrategy from './retryStrategy';

export const indirect = {
  call: (fn, ...args) => fn(...args)
};

export const api = {

  setStatus: (request, apiUrl, store) => {

    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const wowHeaders = wowCustomHeader(state);

    const url = apiUrl;
    // if (!request.isSelf) {     url = `${apiUrl}/${request.userId}`; }

    mouseFlowUtils.setNewPageView(url);
    mouseFlowUtils.setTag(TAG_SET_TECH_STATUS);

    return ajax({
      url: url,
      method: 'post',
      body: request,
      responseType: 'json',
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + accessToken,
        'Accept': 'application/json'

      }
    }).retryWhen(retryStrategy({
      maxRetryAttempts: 1,
      scalingDuration: 1000,
      // Retry a transient 500 from the gateway once. Auth/client errors won't succeed on
      // retry, so let those fail immediately instead of delaying the error by a second.
      excludedStatusCodes: [400, 401, 403],
      failureAction: () => {}
    }));
  },
  getTechStatus: (request, userId, store) => {
    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const wowHeaders = wowCustomHeader(state);


    const url = apiUrls.TECH_STATUS_GET_URL;

    mouseFlowUtils.setNewPageView(url);
    mouseFlowUtils.setTag(TAG_GET_TECH_STATUS);

    return ajax({
      url: url,
      method: 'post',
      body: request,
      responseType: 'json',
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + accessToken,
        'Accept': 'application/json'
      }
    });
  }
};

export const setTechStatusEpic = (action$, store, call = indirect.call) => {
  return action$
    .filter(action => statusEventCheck(action))
    .mergeMap(action => call(api.setStatus, action.request, apiUrls.SET_TECH_STATUS_URL, store).map((payload) => {
      return (actions.setTechStatusWaiting(payload.response, action.request.techStatusChange.userId, action.timestamp));

    }).catch(error => of(actions.setTechStatusFailed(error, action.userId))));
};

// export const getTechStatusEpic = (action$, store, call = indirect.call) => action$
//     .ofType(types.GET_TECH_STATUS_STARTED)
//     .mergeMap(action => call(api.getTechStatus, action.request, action.userId, store).map((payload) => {
//         return (actions.setTechStatusWaiting(payload.response, action.userId));
//     }).catch(error => of(actions.getTechStatusFailed(error, action.userId, action.timestamp))));



// WEBPACK FOOTER //
// ./src/epics/statusEpics.js